import {
  paragraphStyle,
  listStyle,
  bottomMarginItemGlobal,
  fontSizeParagraph,
  lineHeightGlobal,
  INTEND_GLOBAL,
} from "../../utils/pdfConstants";

const LABEL_WIDTH = 150;

export function renderVaihtoehdotBlock({ data, content }) {
  const { options = [] } = data || {};

  for (let optIdx = 0; optIdx < options.length; optIdx++) {
    const opt = options[optIdx];

    // "Vaihtoehto N: Title"
    content.push({
      text: [
        { text: `Vaihtoehto ${optIdx + 1}`, bold: true, font: "Lato" },
        { text: opt.title ? `: ${opt.title}` : "", font: "Lato" },
      ],
      font: "Lato",
      fontSize: fontSizeParagraph,
      lineHeight: lineHeightGlobal,
      margin: [0, optIdx === 0 ? 0 : bottomMarginItemGlobal * 1.5, 0, bottomMarginItemGlobal / 2],
    });

    for (const sec of opt.sections || []) {
      // Section label
      if (sec.label?.trim()) {
        content.push({
          text: sec.label,
          font: "Lato",
          fontSize: fontSizeParagraph,
          lineHeight: lineHeightGlobal,
          margin: [0, 0, 0, bottomMarginItemGlobal / 3],
        });
      }

      // Bullets
      const bullets = (sec.bullets || [])
        .map(b => (typeof b === "string" ? b : b?.text))
        .filter(t => typeof t === "string" && t.trim() !== "");

      if (bullets.length > 0) {
        content.push({
          ul: bullets,
          ...listStyle,
          margin: [INTEND_GLOBAL, 0, 0, bottomMarginItemGlobal],
        });
      }

      // Karkea kustannusarvio
      const costLabel = sec.costLabel?.trim() || "Karkea kustannusarvio";
      const costNums = [sec.costMin, sec.costMax].filter(v => v?.trim()).join(" – ");
      const costUnit = sec.costUnit?.trim() || "";

      if (costNums) {
        content.push({
          columns: [
            {
              width: LABEL_WIDTH,
              text: `${costLabel}:`,
              font: "Lato",
              fontSize: fontSizeParagraph,
              lineHeight: lineHeightGlobal,
            },
            {
              width: "*",
              // Build as inline array so static symbols survive applyHyphenation
              text: [
                { text: "Keskimäärin n. ", font: "Lato", fontSize: fontSizeParagraph },
                { text: costNums, font: "Lato", fontSize: fontSizeParagraph },
                { text: " € / ", font: "Lato", fontSize: fontSizeParagraph },
                { text: costUnit, font: "Lato", fontSize: fontSizeParagraph },
              ],
              lineHeight: lineHeightGlobal,
            },
          ],
          margin: [0, 0, 0, bottomMarginItemGlobal / 3],
        });
      }

      // Kokonaiskustannusarvio — single field; fall back to old min/max for legacy data
      const totalCostVal = sec.totalCost?.trim()
        || [sec.totalCostMin, sec.totalCostMax].filter(v => v?.trim()).join(" – ")
        || "";
      if (totalCostVal) {
        const totalText = [
          { text: "n. ", font: "Lato", fontSize: fontSizeParagraph },
          { text: totalCostVal, font: "Lato", fontSize: fontSizeParagraph },
          { text: " €", font: "Lato", fontSize: fontSizeParagraph },
        ];
        content.push({
          columns: [
            {
              width: LABEL_WIDTH,
              text: "Kokonaiskustannusarvio:",
              font: "Lato",
              fontSize: fontSizeParagraph,
              lineHeight: lineHeightGlobal,
            },
            {
              width: "*",
              text: totalText,
              lineHeight: lineHeightGlobal,
            },
          ],
          margin: [0, 0, 0, bottomMarginItemGlobal / 3],
        });
      }

      // Käyttöikäarvio
      if (sec.lifecycle?.trim()) {
        content.push({
          columns: [
            {
              width: LABEL_WIDTH,
              text: "Käyttöikäarvio:",
              font: "Lato",
              fontSize: fontSizeParagraph,
              lineHeight: lineHeightGlobal,
            },
            {
              width: "*",
              text: [
                { text: ">", font: "Lato", fontSize: fontSizeParagraph },
                { text: sec.lifecycle, font: "Lato", fontSize: fontSizeParagraph },
                { text: " vuotta", font: "Lato", fontSize: fontSizeParagraph },
              ],
              lineHeight: lineHeightGlobal,
            },
          ],
          margin: [0, 0, 0, bottomMarginItemGlobal],
        });
      }
    }
  }
}
